import AOS from "aos";
import "aos/dist/aos.css"; 
import Icon1 from "../../assets/Onesetop/Vector1.png";
import Icon2 from "../../assets/Onesetop/Vector2.png";
import Icon3 from "../../assets/Onesetop/Vector3.png";
import Icon4 from "../../assets/Onesetop/Vector4.png";
import Icon5 from "../../assets/Onesetop/Vector5.png";

AOS.init({
  disable: false, // Ensures animations run on mobile
  once: true, // Only run animations once
});

const OneStop = () => {
  return (
    <div className="relative bg-white my-16 mx-auto max-w-[1380px] ">
      {/* Timeline container */}
      <div className="relative flex flex-col  items-center">
        <div className="absolute h-full w-[3px] bg-[#b4bdd3] ">
          <div
            className={`w-3 h-3 rounded-full bg-[#b4bdd3]  z-10 -translate-x-[40%] top-0 absolute  `}
          ></div>

          <div
            className={`w-3 h-3 rounded-full bg-[#b4bdd3]  z-10 -translate-x-[40%] bottom-0 absolute  `}
          ></div>
        </div>

        {/* Timeline Items */}
        {[
          {
            text: "University Admission Process Assistance",
            position: "right",
            image: Icon1,
          },
          {
            text: "Choose The Right University With Us",
            position: "left",
            image: Icon2,
          },
          {
            text: "100% Placement Assistance And Unlock 800+ Companies' Network",
            position: "right",
            image: Icon3,
          },
          {
            text: "Like-Minded Community Members",
            position: "left",
            image: Icon4,
          },
          {
            text: "Fortune 500 Mentor Community",
            position: "right",
            image: Icon5,
          },
        ].map((item, index) => (
          <div
            key={index}
            className={`flex items-center w-full mb-10 ${
              item.position === "left" ? "justify-start" : "justify-end"
            }`}
          >
            <div
              className={`relative flex items-center w-1/2 ${
                item.position === "left" ? "flex-row-reverse" : ""
              }`}
            >
              {/* Line connector */}

              <div className="absolute max-sm:w-8  w-16 h-0.5 bg-[#b4bdd3]"></div>
              {/* Line Ball mobile  */}
              <div>
                <div
                  className={`w-3 h-3 rounded-full bg-[#b4bdd3]   z-10 md:hidden

                   ${
                     item.position === "left"
                       ? "mr-4 -translate-x-2"
                       : "ml-4 translate-x-2"
                   } `}
                ></div>
                {/* Line Ball desktop  */}
                <div
                  className={`w-3 h-3 rounded-full bg-[#b4bdd3] md:block  hidden  z-10 ${
                    item.position === "left"
                      ? "mr-12 -translate-x-2"
                      : "ml-12 translate-x-2"
                  } `}
                ></div>
              </div>
              <div>
                {/* Icon mobile  */}
                <div
                  className={`w-12 h-12  align-middle z-10 md:hidden
                   ${
                     item.position === "left"
                       ? " translate-x-24  translate-y-1/3  "
                       : "-translate-x-20  translate-y-1/4"
                   } `}
                >
                  <img src={item.image} alt="" />
                </div>
                {/* Icon desktop */}
                <div
                  className={`w-12 h-12  align-middle z-10
                    hidden md:block 
                   ${
                     item.position === "left"
                       ? " translate-x-32  translate-y-1/3  "
                       : "-translate-x-28  translate-y-1/4"
                   } `}
                >
                  <img src={item.image} alt="" />
                </div>
              </div>
              {/* Content desktop */}
              <div
                data-aos={item.position === "left" ? "fade-right" : "fade-left"}
                className={`relative p-[2px] w-[70%] lg:w-[80%]  bg-gradient-to-r to-primary-color   from-secondary-color rounded-lg hidden md:block ${
                  item.position === "left" ? "mr-6" : "ml-6"
                } `}
              >
                <div
                  className={`p-6 max-sm:p-2   bg-white rounded-md   shadow-lg `}
                >
                  <p className="text-[14px]md:text-base  font-medium max-sm:text-[13 px]  text-gray-800">
                    {item.text}
                  </p>
                </div>
              </div>
              {/* Content  mobile */}
              <div
                // data-aos={item.position === "left" ? "fade-right" : "fade-left"}
                className={`relative p-[2px] w-[75%] lg:w-[50%] md:hidden bg-gradient-to-r to-primary-color   from-secondary-color rounded-lg  ${
                  item.position === "left" ? "mr-1" : "ml-1"
                } `}
              >
                <div
                  className={`p-6 max-sm:p-2   bg-white rounded-md   shadow-lg `}
                >
                  <p className="text-[14px]md:text-base  font-medium max-sm:text-[13 px]  text-gray-800">
                    {item.text}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default OneStop;
